// @flow

import { put, select, call, delay } from 'redux-saga/effects'


import {
	change,
	startAsyncValidation,
	stopAsyncValidation
} from 'redux-form'

import {
	usersSaveDataApi,
	usersCheckEmailApi
} from '../apis/users'

import initializers from '../dependencies/initializers'

import { getForm } from '../selectors'
import configurations from '../helpers/misc/configurations'

export function* usersValidateEmailOnUserRegisterWizardForm({email}: Object): Generator<*, *, *> {
	const errors: Object = {email: '<i style="font-size: 12px">This email is already registered. Would you like to <a href='+initializers.recruiter_host+'/auth/login style="color: #a94442; text-decoration: underline">login?</a></i>'}
   
	try {
		yield put(change('UserRegisterWizardForm', 'email', email, true, true))
        
		if (configurations.emailRegex.test(email)) {
			yield put(startAsyncValidation('UserRegisterWizardForm'))

			yield delay(1000)

			const response: Object = yield call(
				usersCheckEmailApi,
				email
			)

			if (response.status === 200) {
				if (response.data.message === 'new_email') {
					yield put(stopAsyncValidation('UserRegisterWizardForm', {}))
				} else {
					yield put(stopAsyncValidation('UserRegisterWizardForm', errors))
				}
			} else if (response.status === 422) {
				yield put(stopAsyncValidation('UserRegisterWizardForm', errors))
			}
		}
        console.log(configurations.emailRegex.test(email))
	} catch (error) {
       
		yield put(stopAsyncValidation('UserRegisterWizardForm', errors))
	}
}

export function* usersSaveData({formName}: Object): Generator<*, *, *> {
	try {
		yield put(startAsyncValidation('UserRegisterWizardForm'))

		const form: Object = yield select(getForm)
		const response: Object = yield call(
			usersSaveDataApi,
			form[formName].values
		)

		if (response.status >= 200 && response.status < 300) {
			yield put(stopAsyncValidation('UserRegisterWizardForm', {}))

			yield put({
				type: 'USERS_ADD_NAVIGATION_PAGE_SUCCESS',
				page: 3
			})
		} else {
			throw response
		}
	} catch (error) {
		yield put(stopAsyncValidation(formName, {}))
	}
}
